import React, { useEffect, useState } from "react";
import ReusableTable from "../../../components/common/table";
import { Space, Tag, Tooltip } from "antd";
import { useNavigate, useSearchParams } from "react-router";
import { ReactComponent as ViewSvg } from "../../../assets/images/action/view.svg";
import CommonFilter from "../../../components/common/filter";
import { getPodcastData } from "../../../redux/action/podcast/podcastAction";
import trimSearchValue, { useDebounce } from "../../../customHooks";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";

const ManagePodcast = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // set page refresh
  const [searchParams, setSearchParams] = useSearchParams();

  const getInitialParams = () => {
    const page = parseInt(searchParams.get("page")) || 1;
    const size = parseInt(searchParams.get("size")) || 10;
    const search_key = searchParams.get("search_key") || "all";
    const search_value = searchParams.get("search_value") || "";
    const status = searchParams.get("status");

    return {
      page,
      size,
      search_key,
      search_value,
      status: status !== null ? Number(status) : undefined,
    };
  };

  const [tableParams, setTableParams] = useState(getInitialParams());

  useEffect(() => {
    const params = {
      page: tableParams.page,
      size: tableParams.size,
      search_key: tableParams.search_key,
      search_value: tableParams.search_value,
    };
    if (tableParams.status !== undefined) {
      params.status = tableParams.status;
    }
    setSearchParams(params);
  }, [tableParams, setSearchParams]);

  // set page refresh end

  const debouncedSearchValue = useDebounce(tableParams.search_value, 500);

  useEffect(() => {
    dispatch(getPodcastData(trimSearchValue(tableParams)));
  }, [
    debouncedSearchValue,
    tableParams.status,
    tableParams.position,
    tableParams.page,
    tableParams.size,
  ]);

  const datas = useSelector((store) => store.getPodcastList?.data);
  const { isLoading } = useSelector((store) => store.getPodcastList);

  const paginationConfig = {
    pageSizeOptions: ["10", "20", "50"],
    showSizeChanger: true,
    showQuickJumper: true,
    total: datas?.count ?? 0,
    current: tableParams.page,
    pageSize: tableParams.size,
    onChange: (page, pageSize) => {
      // setCurrentPage(page);
      setTableParams((prev) => ({ ...prev, page, size: pageSize }));
    },
  };

  const columns = [
    {
      title: "SR. NO.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: (text, record, index) =>
        (tableParams.page - 1) * tableParams.size + index + 1,
    },
    {
      title: "TItle",
      dataIndex: "title_en",
      key: "title_en",
      type: "search",
      render: (text, record) => (
        <Tooltip title={record?.title_en ?? record?.title_es ?? record?.title_pt}>
          {
          (record?.title_en?.length > 15 ? record?.title_en.substring(0, 15) + "..." : record?.title_en) ||
          (record?.title_es?.length > 15 ? record?.title_es.substring(0, 15) + "..." : record?.title_es) ||
          (record?.title_pt?.length > 15 ? record?.title_pt.substring(0, 15) + "..." : record?.title_pt)
          
          }
        </Tooltip>
      ),
    },
    // {
    //   title: "Image (Book Cover)",
    //   dataIndex: "book_cover_en",
    //   // key: "book_cover_en",
    //   type: "search",
    //    render: (book_cover_en, record) => (
    //     <div>
    //       {record?.book_cover_en  ? (
    //         <img
    //           src={`${process.env.REACT_APP_API_IMG_URI}/${record?.book_cover_en}`}
    //           alt="Banner"
    //           style={{
    //             width: "100px",
    //             height: "50px",
    //             objectFit: "contain",
    //             borderRadius: "8px",
    //           }}
    //         />
    //       ) :
    //       record?.book_cover_es  ? (
    //         <img
    //           src={`${process.env.REACT_APP_API_IMG_URI}/${record?.book_cover_es}`}
    //           alt="Banner"
    //           style={{
    //             width: "100px",
    //             height: "50px",
    //             objectFit: "contain",
    //             borderRadius: "8px",
    //           }}
    //         />
    //       ) 
    //    :  record?.book_cover_pt  ? (
    //     <img
    //       src={`${process.env.REACT_APP_API_IMG_URI}/${record?.book_cover_pt}`}
    //       alt="Banner"
    //       style={{
    //         width: "100px",
    //         height: "50px",
    //         objectFit: "contain",
    //         borderRadius: "8px",
    //       }}
    //     />
    //   ) :
          
    //       (
    //         "No Image"
    //       )}
    //     </div>
    //   ),
      
    // },
    {
      title: "Image (Book Cover)",
      dataIndex: "book_cover_pt", // Make sure dataIndex matches at least one defined key
      render: (_, record) => {
        const imagePath =
          record?.book_cover_en ||
          record?.book_cover_es ||
          record?.book_cover_pt;
    
        return imagePath ? (
          <img
            src={`${process.env.REACT_APP_API_IMG_URI}/${imagePath}`}
            alt="Book Cover"
            style={{
              width: "100px",
              height: "50px",
              objectFit: "contain",
              borderRadius: "8px",
            }}
          />
        ) : (
          <span>No Image</span>
        );
      },
    },
    // {
    //   title: "Description",
    //   dataIndex: "short_desc_en",
    //   key: "short_desc_en",
    //   // type: "search",
    //   render: (text) => (
    //     <Tooltip title={text}>
    //       {text?.length > 15 ? text.substring(0, 15) + "..." : text}
    //     </Tooltip>
    //   ),
    // },
    {
      title: "Added On",
      dataIndex: "created_at",
      key: "created_at",
      render: (created_at) =>
        created_at ? dayjs(created_at).format("MM-DD-YYYY") : "-",
    },
  ];

  const actionItems = () => [
    {
      key: "view",
      label: (
        <>
          <ViewSvg style={{ marginRight: 8 }} />
          View Details
        </>
      ),
      onClick: (record) => navigate(`view-podcast/${record?.id}`),
    },
  ];

  const handleFilterChange = (key, value, reset = false) => {
    setTableParams((prev) => {
      if (reset) {
        return {
          ...prev,
          search_key: "",
          search_value: "",
          status: undefined,
          position: undefined,
        };
      }
      if (key === "status" || key === "position") {
        return {
          ...prev,
          [key]: value,
          search_key: "",
          search_value: "",
        };
      }
      return {
        ...prev,
        search_key: key,
        search_value: value,
        status: undefined,
        position: undefined,
      };
    });
  };

  const handleTableChange = (pagination) => {
    setTableParams((prev) => ({
      ...prev,
      page: pagination.current,
      size: pagination.pageSize,
    }));
  };

  return (
    <div>
      <div className="addBx">
        <div className="filterBx">
          <Space>
            <CommonFilter
              columns={columns}
              onFilterChange={handleFilterChange}
            />
          </Space>
        </div>
      </div>
      <div className="tableHeading">List of Podcasts  Added</div>
      <ReusableTable
        columns={columns}
        data={datas?.rows ?? []}
        paginationConfig={{
          ...paginationConfig,
          ...tableParams.pagination,
        }}
        handleTableChange={handleTableChange}
        actionItems={actionItems}
        loading={isLoading}
      />
    </div>
  );
};

export default ManagePodcast;
